// extracted by mini-css-extract-plugin
export var centered = "_v-6";
export var flexible = "_v-5";
export var footer = "_v-k";
export var footerBorder = "_v-l";
export var header = "_v-c";
export var headerBorder = "_v-d";
export var headerDefault = "_v-g";
export var headerMedium = "_v-h";
export var headerPadding = "_v-e";
export var iconAndTitle = "_v-f";
export var large = "_v-4";
export var largePadding = "_v-a";
export var medium = "_v-3";
export var mediumPadding = "_v-9";
export var modal = "_v-0";
export var modalContainer = "_v-b";
export var noPadding = "_v-7";
export var skinny = "_v-1";
export var small = "_v-2";
export var smallPadding = "_v-8";
export var subtitle = "_v-j";
export var title = "_v-i";